import React from 'react';
import { Field } from 'redux-form';
import Typography from '@material-ui/core/Typography';

import Fields from 'components/Fields';
import { wizardStyles } from 'components/Forms/Wizard/wizardUtils';
import { useFormatMessage } from 'components/IntlProvider';

interface GenderType {
  id: number;
  value: string;
  label: string;
}

interface GenderProps {
  genders: GenderType[];
}

const Gender = ({ genders }: GenderProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();

  return (
    <>
      <Typography
        component="h2"
        variant="subtitle1"
        color="inherit"
        className={classes.subtitle}
      >
        {t('fields.wizard.gender', 'Gender')}
      </Typography>
      <Field
        fullWidth
        component={Fields.RadioGroup}
        options={genders}
        name="audience_gender"
      />
    </>
  );
};

export default Gender;
